export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/08ee3b32e72dd5b2b700754671ea2016.svg";